import React from 'react';
import { FaLaptop, FaTabletAlt, FaMobileAlt, FaExclamationTriangle } from 'react-icons/fa';
import PropTypes from 'prop-types';

const MobileRestrictionScreen = ({ 
  title = "Advanced Features Need More Space",
  message = "Training your AI requires precise data input, document uploads, and detailed configurations. These complex operations are optimized for larger screens to ensure accuracy and the best user experience.",
  features = [
    "Better document handling and preview",
    "Enhanced text editing capabilities",
    "Easier file management and organization",
    "More precise control over training parameters"
  ],
  proTip = "For the optimal experience, please use an iPad, tablet, laptop, or desktop computer."
}) => {
  return (
    <div className="min-h-[calc(100vh-64px)] mt-16 bg-gradient-to-br from-blue-50 to-purple-50 p-4 flex items-center justify-center">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-xl border border-blue-100">
        <div className="flex flex-col items-center text-center">
          {/* Warning Icon */}
          <div className="mb-6 text-yellow-500">
            <FaExclamationTriangle className="w-12 h-12 animate-bounce" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            {title}
          </h2>

          {/* Device Icons */}
          <div className="flex items-center justify-center space-x-4 mb-6">
            <div className="flex flex-col items-center opacity-40">
              <FaMobileAlt className="w-8 h-8 text-red-500" />
              <span className="text-xs mt-1 text-red-500">Not Suitable</span>
            </div>
            <div className="w-8 h-px bg-gray-300" />
            <div className="flex flex-col items-center text-green-600">
              <FaTabletAlt className="w-10 h-10" />
              <span className="text-xs mt-1">Perfect!</span>
            </div>
            <div className="w-8 h-px bg-gray-300" />
            <div className="flex flex-col items-center text-green-600">
              <FaLaptop className="w-12 h-12" />
              <span className="text-xs mt-1">Perfect!</span>
            </div>
          </div>

          {/* Main Message */}
          <p className="text-gray-600 mb-6 leading-relaxed">
            {message}
          </p>

          {/* Tips Section */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 w-full mb-6">
            <h3 className="font-semibold text-blue-900 mb-3">Why use a larger device?</h3>
            <ul className="space-y-2 text-sm text-left">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* Recommendation Box */}
          <div className="w-full p-4 bg-blue-50 rounded-lg text-sm text-blue-800 border border-blue-100">
            <p className="font-medium">💡 Pro Tip</p>
            <p className="mt-1">{proTip}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

MobileRestrictionScreen.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  proTip: PropTypes.string
};

export default MobileRestrictionScreen; 